{{#> elements/_dt}}
  {{> elements/_label  }}
{{/elements/_dt}}
<dd>
  {{> elements/_input  type="text" class="date-mask" placeholder="MM/DD/YYYY" pattern="^(0?[1-9]|1[012])[\-\/\.](0?[1-9]|[12][0-9]|3[01])[\-\/\.](19|20)\d{2}$" }}
</dd>
